var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTransactions = function SvgTransactions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.19 18.63a6.44 6.44 0 1 0 0-12.88 6.44 6.44 0 0 0 0 12.88Zm0 1.75a8.19 8.19 0 1 0 0-16.38 8.19 8.19 0 0 0 0 16.38Z",
    fill: "#1D1737"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.494 8.256a.875.875 0 1 0-1.238 1.238l.507.506H8.875a.875.875 0 1 0 0 1.75h7a.875.875 0 0 0 .619-1.493l-2-2Zm-4.238 8.238a.875.875 0 1 0 1.238-1.238l-.506-.506h4.887a.875.875 0 1 0 0-1.75h-7a.875.875 0 0 0-.619 1.494l2 2Z",
    fill: "#1D1737"
  })));
};
export default SvgTransactions;